import { TextButton } from 'seagull';
import { AttachFile } from 'seagull/icons';
import { allowedExtensions, DEFAULT_MAX_TOTAL_SIZE, MAX_FILE_SIZE, useAttachFiles } from "../../hooks/useAttachFiles";
import styles from "./AttachFiles.module.scss";
import { AttachFilesTestIds } from "./AttachFiles.utils";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const AttachFiles = _ref => {
  let {
    onSubmit,
    maxTotalSize = DEFAULT_MAX_TOTAL_SIZE,
    maxFileSize = MAX_FILE_SIZE,
    currentTotalSize = 0
  } = _ref;
  const {
    fileInputRef,
    handleButtonClick,
    handleFileChange
  } = useAttachFiles({
    onSubmit,
    maxTotalSize,
    maxFileSize
  });
  const isDisabled = currentTotalSize >= maxTotalSize;
  const maxTotalSizeMB = maxTotalSize / (1024 * 1024);
  const tooltipTitle = "You've exceeded the ".concat(maxTotalSizeMB, "MB upload limit. Remove files to continue.");
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("input", {
      type: "file",
      multiple: true,
      ref: fileInputRef,
      accept: allowedExtensions.map(ext => ".".concat(ext)).join(','),
      style: {
        display: 'none'
      },
      onChange: handleFileChange,
      "data-testid": AttachFilesTestIds.FileInput()
    }), /*#__PURE__*/_jsx(TextButton, {
      className: styles.button,
      "data-testid": AttachFilesTestIds.Button(),
      underline: "none",
      onClick: handleButtonClick,
      prefixIcon: /*#__PURE__*/_jsx(AttachFile, {}),
      disabled: isDisabled,
      tooltip: isDisabled ? {
        title: tooltipTitle,
        'data-testid': AttachFilesTestIds.ButtonTooltip()
      } : undefined,
      children: "Attach Files"
    })]
  });
};
export default AttachFiles;